import store from '@/store'
import { ref } from '@vue/composition-api'
//* Method to fill param request from table 'Usuarios'
export const configTablePersonas = () => {
  const tableColumns = [

    { key: 'datos', label: 'Datos', sortable: false },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'segundoNombre', label: 'Segundo Nombre', sortable: true },
    { key: 'apellidoPaterno', label: 'Primer Apellido', sortable: true },
    { key: 'apellidoMaterno', label: 'Segundo Apellido', sortable: true },
    { key: 'email', label: 'Correo Principal', sortable: true },
    { key: 'emailAlt', label: 'Correo Alterno', sortable: true },
    { key: 'curp', label: 'CURP', sortable: true },
    { key: 'cuenta', label: 'usuario', sortable: true },
  ]
  return {
    tableColumns,
  }
}
//* Params to fill table data & filters
export const fetchPersonas = persona => {
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 17, token: store.state.cuenta.session.token, data: persona }, //* Request params
    wsType: 'wsusuarios', //* WebService name
    filterGetter: 'usuario/filterPersonas', //* Getter function to filter data
  })
  return { configRequest }
}
